import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../BaseUrl";

export const getMaterialReceiveData = createAsyncThunk(
  "/user/getMaterialReceiveData",
  async (payload  = {}) => {
    try {
      const myurl = `${V_URL}/user/get-receive-issue`;
      const response = await axios({
        method: "post",
        url: myurl,
        data: payload,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
        },
      });
      const data = response?.data;
      if (data.success === true) {
        return data;
      } else {
        throw new Error(data);
      }
    } catch (error) {
      console.log(error, "error");
      toast.error(error.response.data.message);
      return error;
    }
  }
);

const getMaterialReceiveDataSlice = createSlice({
  name: "getMaterialReceiveData",
  initialState: {
    user: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMaterialReceiveData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMaterialReceiveData.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(getMaterialReceiveData.rejected, (state, action) => {
        state.user = null;
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default getMaterialReceiveDataSlice.reducer;
